document.addEventListener('DOMContentLoaded' , () =>{
    // community - faq-lists-page
    if(document.querySelector('.faq-lists-page')){
        let button = document.querySelectorAll('.qna-lists--q')
        const addButton = document.querySelector('.btn--arrow')
        
        function toggleOpen (e) {
            const el = e.target.closest('li')
            const elClass = el.classList.contains('on')
            const AllLi = document.querySelectorAll('.qna-lists>li')
            const wrapper = el.querySelector('.qna-lists--a')
            const content = el.querySelector('.qna-lists--a__con')
            AllLi.forEach((li) => {
                li.classList.remove('on');
                li.querySelector('.qna-lists--a').style.height = '0px';
            })
            if (!elClass) {
                
                el.classList.add('on');
                const height = content.getBoundingClientRect().height;
                wrapper.style.height = `${height}px`;
            }else{
                // wrapper.style.height = `${content.getBoundingClientRect().height}px`;
                wrapper.style.height = '0px';
            }
        }
        addButton.addEventListener('click', ()=>{
            button = document.querySelectorAll('.qna-lists--q')
            button.forEach((q) =>{
                q.addEventListener('click', toggleOpen)
            })
        })
        button.forEach((q) =>{
            q.addEventListener('click', toggleOpen)
        })
    };
    
    // community - give-view-page
    if(document.querySelector('.give-view-page')){
        let btnReply = document.querySelectorAll('.btn_reply');
        let btnEdit = document.querySelectorAll('.btn_edit');
        btnReply.forEach((q) =>{
            q.addEventListener('click', revewFirstOpen)
        })
        btnEdit.forEach((q) =>{
            q.addEventListener('click', revewFirstOpen)
        })
        function revewFirstOpen(e){
            let reviewLi = e.target.closest('li.review-list-area');
            let reviewLiBtn = reviewLi.querySelectorAll('.review-list--con__btn>button');
            let reviewTxtArea = reviewLi.querySelector('.enroll_txt');
            let reviewReplyBtn = reviewLi.querySelector('.btn_reply');

            let reviewLiClass = reviewLi.classList.contains('active');
            let btnActiveClass = e.target.classList.contains('on');

            if(!btnActiveClass){
                reviewLiBtn.forEach((el) =>{
                    console.log(el)
                    el.classList.remove('on');
                })
                e.target.classList.add('on');

                if(e.target.classList.contains('btn_reply')){
                    e.target.innerHTML = "답글 취소";
                }else{
                    reviewReplyBtn.innerHTML = "답글 달기";
                }

                if(!reviewLiClass){
                    reviewLi.classList.add('active');
                    reviewTxtArea.focus()
                }else{
                    reviewTxtArea.focus()
                }
            }else{
                reviewReplyBtn.innerHTML = "답글 달기";

                if(reviewLiClass){
                    reviewLiBtn.forEach((el) =>{
                        el.classList.remove('on');
                    })
                    reviewLi.classList.remove('active');
                }
            }
        }
    }
});
